import { render, staticRenderFns } from "./DevolucionesFormComponent.vue?vue&type=template&id=6de777a2&"
import script from "./DevolucionesFormComponent.vue?vue&type=script&lang=js&"
export * from "./DevolucionesFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports